export const availableCommandsUrl = (assetId: string) => `commands/asset/${assetId}/`;
export const commandListUrl = 'commands/available/';
export const commandsUrl = 'commands/';
